var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { withNotifySentry } from "./helpers";
export function getLearningTasks(categoryId) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield withNotifySentry(() => axios.get(`/api/translator/learning_categories/${categoryId}/tasks`));
    });
}
function fileToBase64(file) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const result = reader.result;
                // Remove the data URL prefix (e.g., "data:image/png;base64,")
                const base64 = result.split(",")[1];
                resolve(base64);
            };
            reader.onerror = (error) => reject(error);
        });
    });
}
export function updateLearningTaskAnswerVersion(data) {
    return __awaiter(this, void 0, void 0, function* () {
        const payload = {
            text: data.text,
            status: data.status,
        };
        if (data.attachments && data.attachments.length > 0) {
            payload.attachments = yield Promise.all(data.attachments.map((file) => __awaiter(this, void 0, void 0, function* () {
                return ({
                    filename: file.name,
                    content_type: file.type,
                    data: yield fileToBase64(file),
                });
            })));
        }
        return yield withNotifySentry(() => axios.put(`/api/translator/learning_tasks/${data.taskId}/answers/${data.answerId}/versions/${data.id}`, payload));
    });
}
export function createLearningTaskAnswerVersion(data) {
    return __awaiter(this, void 0, void 0, function* () {
        const payload = {
            text: data.text,
            status: data.status,
        };
        if (data.attachments && data.attachments.length > 0) {
            payload.attachments = yield Promise.all(data.attachments.map((file) => __awaiter(this, void 0, void 0, function* () {
                return ({
                    filename: file.name,
                    content_type: file.type,
                    data: yield fileToBase64(file),
                });
            })));
        }
        return yield withNotifySentry(() => axios.post(`/api/translator/learning_tasks/${data.taskId}/answers/${data.answerId}/versions`, payload));
    });
}
export function createLearningTaskAnswer(taskId) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield withNotifySentry(() => axios.post(`/api/translator/learning_tasks/${taskId}/answers`));
    });
}
export function deleteLearningTaskAnswerVersionAttachment(data) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield withNotifySentry(() => axios.delete(`/api/translator/learning_tasks/${data.taskId}/answers/${data.answerId}/versions/${data.versionId}/attachments/${data.attachmentId}`));
    });
}
